import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import Stepper from "./stepper"
import axios from "axios"
import Select from 'react-select'
import Spinner from "../spinner"
import moment from "moment/moment"
import saveLead from "../../Config/GlobalFunctions"
import { useNavigate } from 'react-router-dom';
import configData from "../../config.json"
import { motion } from "framer-motion"
import { ToastContainer, toast } from 'react-toastify'

function Complete() {
  const [data, setData] = useState(JSON.parse(localStorage.getItem('info')))
  const [estadoCivil, setEstadoCivil] = useState([])
  const [estadoCivilId, setEstadoCivilId] = useState('0')
  const [cellphoneNumber, setCellphoneNumber] = useState(data.numeroCel)
  const [residenceNumber, setResidenceNumber] = useState(data.numeroTel)
  const [familyNumber, setFamilyNumber] = useState(data.numeroFam)
  const [mail, setMail] = useState(data.correo)
  const [validMail, setValidMail] = useState(false)
  const [colegio, setColegio] = useState([])
  const [collegeId, setCollegeId] = useState(data.colegio)
  const [provincia, setProvincia] = useState([])
  const [provinciaId, setProvinciaId] = useState(data.provincia == '' ? '1' : data.provincia)
  const [canton, setCanton] = useState([])
  const [cantonId, setCantonId] = useState(data.canton == '' ? '12' : data.canton.toString())
  const [distrito, setDistrito] = useState([])
  const [distritoId, setDistritoId] = useState(data.distrito.toString())
  const [details, setDetails] = useState(data.direccion)
  const [loading, setLoading] = useState(false)
  const [adecuacion, setAdecuacion] = useState([])
  const [isAdecuacion, setisAdecuacion] = useState(false)
  const [adecuacionId, setAdecuacionId] = useState('0')
  const [adecuacionDesc, setAdecuacionDesc] = useState('')
  const [continueStep, setContinueStep] = useState(false)
  const [formatDate, setFormatDate] = useState()
  const navigate = useNavigate()

  const handleInputProvincia = (event) => {

    const value = event.target.value
    setProvinciaId(value)
    changeCantones(value)

  }

  const handleField = (event) => {
    const id = event.target.id
    if (id == 'EstadoCivil') {
      setEstadoCivilId(event.target.value)
    }
    if (id == 'CellphoneNumber') {
      const result = event.target.value.replace(/\D/g, '');
      setCellphoneNumber(result)
    }
    if (id == 'ResidenceNumber') {
      const result = event.target.value.replace(/\D/g, '');
      setResidenceNumber(result)
    }
    if (id == 'FamilyNumber') {
      const result = event.target.value.replace(/\D/g, '');
      setFamilyNumber(result)
    }
    if (id == 'Mail') {
      const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

      if (!emailRegex.test(event.target.value)) {
        setValidMail(true)
      } else {
        setValidMail(false)
      }

      setMail(event.target.value)

    }

    if (id === 'Details') {
      console.log(event.target.text)
      setDetails(event.target.value)
    }

    if (id === 'Observaciones') {
      console.log(event.target.value)
      setAdecuacionDesc(event.target.value)
    }
    validateRequestedFields()
    validateFields()

  }

  const handleChangeCollege = (selectedOption) => {
    setCollegeId(selectedOption.value);
    validateFields()
  }

  const handleInputCanton = (event) => {
    const value = event.target.value
    setCantonId(value)
    changeDistritos(value)
  }

  const handleInputDistrito = (event) => {
    const value = event.target.value
    setDistritoId(value)
  }

  const handleAdecuacionId = (event) => {
    const value = event.target.value
    setAdecuacionId(value)
  }

  const handleIsAdecuacion = (event) => {
    setLoading(true)
    setisAdecuacion(true)
    validateFields()
    setLoading(false)
  }

  const handleIsNotAdecuacion = (event) => {
    setLoading(true)
    setisAdecuacion(false)
    setAdecuacionId('0')
    validateFields()
    setLoading(false)
  }


  const changeCantones = (provinceId) => {
    setLoading(true)
    axios.get(`${configData.API_URL}/data/cantones/` + provinceId)
      .then(response => {
        setCanton(response.data)
        setCantonId(response.data[0].P07COD)
        setLoading(false)
      })
      .catch(error => {
        console.log(error);
      });
  }

  const changeDistritos = (cantonId) => {
    setLoading(true)
    axios.get(`${configData.API_URL}/data/distritos/` + provinciaId + '/' + cantonId)
      .then(response => {
        setDistrito(response.data)
        setDistritoId(response.data[0].P08COD)
        setLoading(false)
      })
      .catch(error => {
        console.log(error);
      });
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    setLoading(true)
    if (validateFields()) {
      let data = JSON.parse(localStorage.getItem('info'))
      data.canton = cantonId
      data.provincia = provinciaId
      data.distrito = distritoId
      data.correo = mail
      data.direccion = details
      data.estadoCivil = estadoCivilId
      data.numeroCel = cellphoneNumber
      data.numeroFam = familyNumber
      data.numeroTel = residenceNumber
      data.colegio = collegeId
      localStorage.setItem('info', JSON.stringify(data))

      let lead = {
        "M12CED": data.personId,
        "M12NOM": data.name,
        "M12AP1": data.firstName,
        "M12AP2": data.secondName,
        "M12SEX": data.gender,
        "M12FNA": data.birthDate,
        "M12EST": data.estadoCivil,
        "M12CEL": data.numeroCel,
        "M12DIR": data.direccion,
        "M12EMA": data.correo,
        "M10COD": data.colegio,
        "P06COD": data.provincia.toString(),
        "P07COD": data.canton,
        "P08COD": data.distrito,
        "M09COD": "CR",
        "M01COD": '',
        "M02COD": '',
        "M03COD": '',
        "M04COD": '',
        "M05COD": '',
        "M07COD": '',
        "M12CAR": '',
        "ETAPA": 'Ingreso datos personales',
        "ACEPTA_CC": '',
        "FECHA_INGRESO": ''
      }

      let leadLog = {
        "IdentificationNumber": data.personId,
        "IdentificationCode": 1,
        "Name": data.name,
        "LastName": data.firstName + ' ' + data.secondName,
        "Gender": data.gender,
        "Birthdate": data.birthDate,
        "CivilStatusCode": data.estadoCivil.toString(),
        "CivilStatus": '',
        "TelephoneNumber": residenceNumber,
        "CellphoneNumber": cellphoneNumber,
        "FamiliarNumber": familyNumber,
        "OtherSigns": details,
        "Email": data.correo,
        "CollegeCode": data.colegio,
        "College": '',
        "ProvinceCode": data.provincia.toString(),
        "Province": '',
        "CantonCode": data.canton.toString(),
        "Canton": '',
        "DistrictCode": data.distrito.toString(),
        "District": ''
      }

      let adecuacy = {
        "Code": adecuacionId,
        "Description": adecuacionDesc
      }

      sessionStorage.setItem('lead', JSON.stringify(lead))
      sessionStorage.setItem('leadInfo', JSON.stringify(leadLog))
      sessionStorage.setItem('adecuacy', JSON.stringify(adecuacy))
      saveLead()

      navigate('/information/terms', { replace: true });
    } else {
      validateRequestedFields()
      setLoading(false)
      toast.warning('Por favor complete los campos requeridos', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  }

  const validateRequestedFields = () => {
    // Obtén el div por su ID (cambia "miDiv" por el ID de tu div)
    var div = document.getElementById('personalInfo');

    // Utiliza querySelectorAll para obtener todos los elementos input dentro del div
    var inputs = div.querySelectorAll('.validate');

    inputs.forEach(function (input) {
      if (input.getAttribute('type') === 'text' || input.getAttribute('type') === 'mail') {
        let id = input.id
        let val = input.value
        if (val == '') {
          input.classList.add('is-invalid')
        } else {
          input.classList.remove('is-invalid')
        }
      } else {
        if (input.nodeName === 'TEXTAREA') {
          if (input.value == '') {
            input.classList.add('is-invalid')
          } else {
            input.classList.remove('is-invalid')
          }
        }

        if (input.nodeName === 'SELECT') {
          if (input.id !== 'EstadoCivil') {
            if (input.value == '0') {
              input.classList.add('is-invalid')
            } else {
              input.classList.remove('is-invalid')
            }
          }
        }
      }
    })


  }

  const validateFields = () => {
    let response = true
    if (cellphoneNumber === '') {
      response = false
    }
    if (residenceNumber === '') {
      response = false
    }
    if (familyNumber === '') {
      response = false
    }
    if (mail === '' && !validMail) {
      response = false
    }

    if (collegeId === '') {
      response = false

    }
    if (provinciaId === 0) {
      response = false

    }

    if (cantonId === 0) {
      response = false

    }

    if (distritoId === 0) {
      response = false

    }

    if (isAdecuacion) {
      if (adecuacionId === '0') {
        response = false
      }

      if (adecuacionDesc === '') {
        response = false
      }
    }

    setContinueStep(response)
    console.log(response)
    return response
  }

  useEffect(() => {
    setLoading(true)


    var FormatDate = new Date(data.birthDate)

    setFormatDate(moment(FormatDate).format("YYYY-MM-DD"))

    const ec = [
      {
        id: '0',
        value: 'Soltero(a)'
      },
      {
        id: '1',
        value: 'Casado(a)'
      },
      {
        id: '2',
        value: 'Divorciado(a)'
      },
      {
        id: '3',
        value: 'Viudo(a)'
      },
      {
        id: '4',
        value: 'Union Libre'
      },
    ]

    setEstadoCivil(ec)

    axios.get(`${configData.API_URL}/data/colegios`)
      .then(response => {
        var info = response.data
        var colegios = []

        info.forEach(element => {
          colegios.push({
            value: element.M10COD,
            label: element.M10DES
          })
        })

        setColegio(colegios)
      })
      .catch(error => {
        console.log(error);
      })

    axios.get(`${configData.API_URL}/data/provincias`)
      .then(response => {
        setProvincia(response.data)
        setProvinciaId(provinciaId)
        changeCantones(provinciaId)
        changeDistritos(cantonId)
      })
      .catch(error => {
        console.log(error);
      });

    axios.get(`${configData.API_URL}/data/adecuaciones`)
      .then(response => {
        var info = response.data
        setAdecuacion(info)
      })
      .catch(error => {
        console.log(error);
      })

    if (isAdecuacion) {
      document.getElementById('inlineRadio1').checked = true
      document.getElementById('inlineRadio2').checked = false
    } else {
      document.getElementById('inlineRadio2').checked = true
      document.getElementById('inlineRadio1').checked = false
    }
  }, []);



  return (
    <div>
      <motion.main
        className="main__container"
        initial={{ width: 0 }}
        animate={{ width: "100%" }}
        exit={{ x: "100%", opacity: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Stepper step="1"></Stepper>
        <section className="container-fluid ">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
          <Spinner show={loading}></Spinner>
          <form className="row needs-validation" id="personalInfo" novalidate>
            <div className="offset-lg-3 col-lg-6 col-sm-12 mt-5 pb-3 mb-5">
              <div className="">
                <div className="row">
                  <legend>Datos personales</legend>
                  <hr className="bg-green lines" />
                </div>
                <div className="row">
                  <div className="col-lg-4">
                    <label for="personId" className="form-label">Número identificación</label>
                    <input type="text" value={data.personId} className="form-control disabled" id="PersonId" disabled />
                  </div>
                  <div className="col-lg-4">
                    <label for="name" className="form-label">Nombre</label>
                    <input type="text" value={data.name} className="form-control disabled" id="name" disabled />
                  </div>
                  <div className="col-lg-4">
                    <label for="firstname" className="form-label">Apellidos</label>
                    <input type="text" value={`${data.firstName} ${data.secondName}`} className="form-control disabled" id="Firstname" disabled />
                  </div>
                  <div className="col-lg-4">
                    <label for="gender" className="form-label">Género</label>
                    <input type="text" value={data.gender} className="form-control disabled" id="Gender" disabled />
                  </div>
                  <div className="col-lg-4">
                    <label for="birthdate" className="form-label">Fecha de nacimiento</label>
                    <input type="date" value={formatDate} className="form-control disabled" id="Birthdate" disabled />
                  </div>
                  <div className="col-lg-4">
                    <label for="Age" className="form-label">Edad</label>
                    <input type="text" value={data.edad} className="form-control disabled" id="Age" disabled />
                  </div>
                </div>
              </div>
              <div className="mt-5">
                <div className="row">
                  <legend>Información Contacto</legend>
                  <hr className="bg-green lines" />
                </div>
                <div className="row">
                  <div className="col-lg-4">
                    <label for="EstadoCivil" className="form-label">Estado Civil *</label>
                    <select name="" className="form-select validate" id="EstadoCivil" onChange={handleField}>
                      {estadoCivil.map(option => (
                        <option key={option.id} value={option.id}>{option.value}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-lg-4">
                    <label for="CellphoneNumber" className="form-label">Número celular *</label>
                    <input type="text" className="form-control validate" id="CellphoneNumber" onChange={handleField} value={cellphoneNumber} maxLength={8} />
                  </div>
                  <div className="col-lg-4">
                    <label for="ResidenceNumber" className="form-label">Número Residencia *</label>
                    <input type="text" className="form-control validate" id="ResidenceNumber" onChange={handleField} value={residenceNumber} maxLength={8} />
                  </div>
                  <div className="col-lg-4">
                    <label for="FamilyNumber" className="form-label">Número de Familiar *</label>
                    <input type="text" className="form-control validate" id="FamilyNumber" onChange={handleField} value={familyNumber} maxLength={8} />
                  </div>
                  <div className="col-lg-4">
                    <label for="Mail" className="form-label">Correo electrónico *</label>
                    <input type="mail" className="form-control validate" id="Mail" onChange={handleField} value={mail} />
                    <div class={`text-red ${validMail ? '' : 'd-none'}`}>
                      Por favor brinde un correo válido
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <label for="College" className="form-label">Colegio *</label>
                    <Select options={colegio} id="College" onChange={handleChangeCollege} placeholder="Selecciona el colegio" className="" />
                  </div>
                </div>
              </div>
              <div className="mt-5">
                <div className="row">
                  <legend>Dirección</legend>
                  <hr className="bg-green lines" />
                </div>
                <div className="row">
                  <div className="col-lg-4">
                    <label for="Province" className="form-label">Provincia *</label>
                    <select name="" className="form-select" id="Province" onChange={handleInputProvincia} value={provinciaId}>
                      {provincia.map(option => (
                        <option key={option.P06COD} value={option.P06COD}>{option.P06DES}</option>
                      ))}
                    </select>

                  </div>
                  <div className="col-lg-4">
                    <label for="Canton" className="form-label">Canton *</label>
                    <select name="" className="form-select" id="Canton" onChange={handleInputCanton} value={cantonId}>
                      {canton.map(option => (
                        <option key={option.P07COD} value={option.P07COD}>{option.P07DES}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-lg-4">
                    <label for="District" className="form-label">Distrito *</label>
                    <select name="" className="form-select" id="District" onChange={handleInputDistrito} value={distritoId}>
                      {distrito.map(option => (
                        <option key={option.P08COD} value={option.P08COD}>{option.P08DES}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-lg-12">
                    <label for="Details" className="form-label">Otras señas</label>
                    <textarea className="form-control validate" id="Details" onChange={handleField} value={details} />
                  </div>
                </div>
              </div>
              <div className="mt-5 mb-5">
                <div className="row">
                  <legend>Adecuación Curricular</legend>
                  <hr className="bg-green lines" />
                </div>
                <div className="row">
                  <div className="col-lg-6 pt-3">
                    <label for="inputEmail4" className="form-label">¿Has contado con o requerís de adecuación curricular? *</label>
                  </div>
                  <div className="col-lg-6 pt-3">
                    <div className="form-check form-check-inline">
                      <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="true" onClick={handleIsAdecuacion} />
                      <label className="form-check-label" for="inlineRadio1" >Sí</label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="false" onClick={handleIsNotAdecuacion} />
                      <label className="form-check-label" for="inlineRadio2">No</label>
                    </div>
                  </div>
                </div>
                <div className={`row mt-4 ${isAdecuacion == true ? "" : "d-none"}`}>
                  <div className="col-lg-6">
                    <label for="inputEmail4" className="form-label">Tipo de adecuación: </label>
                    <select name="" className="form-select validate" id="Adecuacion" onChange={handleAdecuacionId} value={adecuacionId}>
                      <option value="0" disabled>Seleccione el tipo de adecuación</option>
                      {adecuacion.map(option => (
                        <option key={option.M626COD} value={option.M626COD}>{option.M626DES}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-lg-12">
                    <label for="inputEmail4" className="form-label">Observaciones</label>
                    <textarea type="text" className="form-control" id="Observaciones" onChange={handleField} />
                  </div>
                </div>

                <div className="row pt-2 pb-5 pt-5">
                  <div className="pt-2 offset-lg-2 col-lg-4 col-sm-12 text-center">
                    <Link className="btn btn-lg w-100 btn-red" to="/information/identify">Regresar</Link>
                  </div>
                  <div className="pt-2 col-lg-4 col-sm-12 text-center">
                    <button type="submit" className={`btn btn-lg w-100 btn-yellow`} onClick={handleSubmit}>Continuar</button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </motion.main>
    </div>
  )
}

export default Complete 